<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="1200" scrollable>
			<v-card>
				<v-card-title class="text-h6">Detail Pembayaran Dana Penjualan {{datetime | tanggalIna }}, Total Transfer {{totalTransfer | toRupiah}}</v-card-title>
				<v-card-text>
					<EwalletWithdrawDetail v-if="dialog" asDetail :logID="logID"></EwalletWithdrawDetail>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideModal">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import EwalletWithdrawDetail from '../EwalletWithdrawDetail'
export default {
	components: {
		EwalletWithdrawDetail
	},
	data () {
		return {
			dialog: false,
			datetime: '',
			totalTransfer: '',
			params: {},
			logID: '',
		}
	},
	methods: {
		async showModal(data) {
			this.logID = data.ewallet_withdrawal_log_id
			this.params = data
			this.dialog = true
			this.datetime = data.ewallet_withdrawal_log_datetime
			this.totalTransfer = data.ewallet_withdrawal_log_total_transfer
		},
		hideModal() {
			this.dialog = false
		},
	},
	watch: {
	},
	created() {
	}
}
</script>
